import PropTypes from 'prop-types';

/**
 * Describes an object from `/api/refunds/new?order_id=XXX`,
 * which describes what can be refunded on an order.
 */
const RefundableType = PropTypes.shape({
  order_id: PropTypes.number,
  order_amount: PropTypes.string,
  refundable_amount: PropTypes.string,
  refundable_categories: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    amount: PropTypes.string
  })),
  legacy_transaction: PropTypes.bool,
  dashboard_url: PropTypes.string
});

export default RefundableType;
